import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { BankDto } from "./bank.dto";
import { CreateBankDto } from "./create-bank.dto";
import { UpdateBankDto } from "./update-bank.dto";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class BanksResource extends ResourceBaseService<BankDto, CreateBankDto, UpdateBankDto> {
  protected EntityDto = BankDto;
  protected CreateEntityDto = CreateBankDto;
  protected UpdateEntityDto = UpdateBankDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/banks");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }
}
